import { render, staticRenderFns } from "./CertSave588.vue?vue&type=template&id=1911c896&scoped=true&"
import script from "./CertSave588.vue?vue&type=script&lang=js&"
export * from "./CertSave588.vue?vue&type=script&lang=js&"
import style0 from "./CertSave588.vue?vue&type=style&index=0&id=1911c896&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1911c896",
  null
  
)

export default component.exports